function debounce(fn, time) {
  let timer;
  return function (...argu) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      fn(...argu);
      clearTimeout(timer);
      timer = null;
    }, time);
  };
}
function isFunction(param) {
  return Object.prototype.toString.call(param) === "[object Function]";
}

let inputFunction = (event) => {
  console.log(event);
};

// 由于要同时支持 input 输入框和封装 input 的组件，因此需要去找到input这个元素。
function findInput(el) {
  const quene = [];
  quene.push(el);
  while (quene.length > 0) {
    const current = quene.shift();
    if (current.tagName === "INPUT") {
      return current;
    }
    if (current.childNodes) {
      quene.push(...current.childNodes);
    }
  }
  return null;
}

export default {
  mounted(el, binding) {
    const { value, arg } = binding;
    if (value && isFunction(value)) {
      let timeout = 600;
      if (arg && !Number.isNaN(arg)) {
        timeout = Number(arg);
      }
      inputFunction = debounce(value, timeout); // 执行函数防抖处理
      const input = findInput(el);
      el._INPUT = input;
      if (input) {
        input.addEventListener("input", inputFunction);
      }
    }
  },
  beforeUnmount(el) {
    if (el._INPUT) {
      el._INPUT.removeEventListener("input", inputFunction);
      el._INPUT = null;
    }
  },
};
